module.exports = __webpack_public_path__ + "static/media/logo-horizontal-nyko-white2.4fd5a40f.png";